@if (!addFriendsScreen()) {
  <div class="friends-actions">
    <div class="friends-count">
      You have <span> {{ friendsTotal() }} </span> friends
    </div>

    <div class="actions">
      <div class="search-box">
      <span class="search-icon">
        <app-icon size="small" color="#9BB2DD" name="search"></app-icon>
      </span>
        <input [formControl]="searchFriend" type="text" placeholder="Search"/>
      </div>

      <div class="add-friend">
        <button appButton buttonType="create" color="gray" (click)="openAddFriendScreen()">Add Friend</button>
      </div>
    </div>
  </div>

  <div #scrollFriendsContainer class="grid-container" (scroll)="onFriendsScroll()">
    @for (friend of friendsList(); track friend.id) {
      <app-friend-card (eventTriggered)="onEvent($event)" [friend]="friend"></app-friend-card>
    }
  </div>
}

@if (addFriendsScreen()) {
  <div class="friends-actions">
    <a aria-hidden="true" class="back-button" (click)="backToFriendsList()">
      <app-icon class="mr-2" name="heroArrowLongLeft"></app-icon>
      Back
    </a>

    <div class="actions">
      <div class="search-box">
      <span class="search-icon">
        <app-icon size="small" color="#9BB2DD" name="search"></app-icon>
      </span>
        <input [formControl]="searchPeople" type="text" placeholder="Search"/>
      </div>
    </div>
  </div>

  @if (usersList().length) {
    <div #scrollUsersContainer class="grid-container" (scroll)="onUsersScroll()">
      @for (user of usersList(); track user.id) {
        <app-user-card [user]="user"></app-user-card>
      }
    </div>
  } @else {
    <div class="empty-screen">
      <ng-icon class="icon" name="addUser"></ng-icon>
    </div>
  }
}

